var UploadErrorType = /* @__PURE__ */ ((UploadErrorType2) => {
  UploadErrorType2["BucketUpload"] = "bucket_upload";
  UploadErrorType2["Length"] = "length";
  UploadErrorType2["FilenameExtension"] = "filename_extension";
  UploadErrorType2["Number"] = "number";
  UploadErrorType2["Filesize"] = "filesize";
  UploadErrorType2["Mimetype"] = "mimetype";
  return UploadErrorType2;
})(UploadErrorType || {});
var BucketUploadErrorMessage = /* @__PURE__ */ ((BucketUploadErrorMessage2) => {
  BucketUploadErrorMessage2["FilesizeTooSmall"] = "filesize_too_small";
  BucketUploadErrorMessage2["FilesizeTooLarge"] = "filesize_too_large";
  BucketUploadErrorMessage2["UnexpectedContent"] = "unexpected_content";
  BucketUploadErrorMessage2["FilepathTooLong"] = "filepath_too_long";
  BucketUploadErrorMessage2["Timeout"] = "timeout";
  BucketUploadErrorMessage2["RateLimit"] = "rate_limit";
  return BucketUploadErrorMessage2;
})(BucketUploadErrorMessage || {});
const SECOND = 1e3;
const MINUTE = 60 * SECOND;
const DEFAULT_POLL_DELAY = 5 * SECOND;
const DEFAULT_TIMEOUT = 3 * MINUTE;
const DEFAULT_FILE_UPLOAD_RETRIES = 3;

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var ErrorCodes = /* @__PURE__ */ ((ErrorCodes2) => {
  ErrorCodes2["AccessDenied"] = "AccessDenied";
  ErrorCodes2["AccountProblem"] = "AccountProblem";
  ErrorCodes2["AllAccessDisabled"] = "AllAccessDisabled";
  ErrorCodes2["AmbiguousGrantByEmailAddress"] = "AmbiguousGrantByEmailAddress";
  ErrorCodes2["AuthorizationHeaderMalformed"] = "AuthorizationHeaderMalformed";
  ErrorCodes2["BadDigest"] = "BadDigest";
  ErrorCodes2["BucketAlreadyExists"] = "BucketAlreadyExists";
  ErrorCodes2["BucketAlreadyOwnedByYou"] = "BucketAlreadyOwnedByYou";
  ErrorCodes2["BucketNotEmpty"] = "BucketNotEmpty";
  ErrorCodes2["CredentialsNotSupported"] = "CredentialsNotSupported";
  ErrorCodes2["CrossLocationLoggingProhibited"] = "CrossLocationLoggingProhibited";
  ErrorCodes2["EntityTooSmall"] = "EntityTooSmall";
  ErrorCodes2["EntityTooLarge"] = "EntityTooLarge";
  ErrorCodes2["ExpiredToken"] = "ExpiredToken";
  ErrorCodes2["IllegalLocationConstraintException"] = "IllegalLocationConstraintException";
  ErrorCodes2["IllegalVersioningConfigurationException"] = "IllegalVersioningConfigurationException";
  ErrorCodes2["IncompleteBody"] = "IncompleteBody";
  ErrorCodes2["IncorrectNumberOfFilesInPostRequest"] = "IncorrectNumberOfFilesInPostRequest";
  ErrorCodes2["InlineDataTooLarge"] = "InlineDataTooLarge";
  ErrorCodes2["InternalError"] = "InternalError";
  ErrorCodes2["InvalidAccessKeyId"] = "InvalidAccessKeyId";
  ErrorCodes2["InvalidAccessPoint"] = "InvalidAccessPoint";
  ErrorCodes2["InvalidAddressingHeader"] = "InvalidAddressingHeader";
  ErrorCodes2["InvalidArgument"] = "InvalidArgument";
  ErrorCodes2["InvalidBucketName"] = "InvalidBucketName";
  ErrorCodes2["InvalidBucketState"] = "InvalidBucketState";
  ErrorCodes2["InvalidDigest"] = "InvalidDigest";
  ErrorCodes2["InvalidEncryptionAlgorithmError"] = "InvalidEncryptionAlgorithmError";
  ErrorCodes2["InvalidLocationConstraint"] = "InvalidLocationConstraint";
  ErrorCodes2["InvalidObjectState"] = "InvalidObjectState";
  ErrorCodes2["InvalidPart"] = "InvalidPart";
  ErrorCodes2["InvalidPartOrder"] = "InvalidPartOrder";
  ErrorCodes2["InvalidPayer"] = "InvalidPayer";
  ErrorCodes2["InvalidPolicyDocument"] = "InvalidPolicyDocument";
  ErrorCodes2["InvalidRange"] = "InvalidRange";
  ErrorCodes2["InvalidRequest"] = "InvalidRequest";
  ErrorCodes2["InvalidSecurity"] = "InvalidSecurity";
  ErrorCodes2["InvalidSOAPRequest"] = "InvalidSOAPRequest";
  ErrorCodes2["InvalidStorageClass"] = "InvalidStorageClass";
  ErrorCodes2["InvalidTargetBucketForLogging"] = "InvalidTargetBucketForLogging";
  ErrorCodes2["InvalidToken"] = "InvalidToken";
  ErrorCodes2["InvalidURI"] = "InvalidURI";
  ErrorCodes2["KeyTooLongError"] = "KeyTooLongError";
  ErrorCodes2["MalformedACLError"] = "MalformedACLError";
  ErrorCodes2["MalformedPOSTRequest"] = "MalformedPOSTRequest";
  ErrorCodes2["MalformedXML"] = "MalformedXML";
  ErrorCodes2["MaxMessageLengthExceeded"] = "MaxMessageLengthExceeded";
  ErrorCodes2["MaxPostPreDataLengthExceededError"] = "MaxPostPreDataLengthExceededError";
  ErrorCodes2["MetadataTooLarge"] = "MetadataTooLarge";
  ErrorCodes2["MethodNotAllowed"] = "MethodNotAllowed";
  ErrorCodes2["MissingAttachment"] = "MissingAttachment";
  ErrorCodes2["MissingContentLength"] = "MissingContentLength";
  ErrorCodes2["MissingRequestBodyError"] = "MissingRequestBodyError";
  ErrorCodes2["MissingSecurityElement"] = "MissingSecurityElement";
  ErrorCodes2["MissingSecurityHeader"] = "MissingSecurityHeader";
  ErrorCodes2["NoLoggingStatusForKey"] = "NoLoggingStatusForKey";
  ErrorCodes2["NoSuchBucket"] = "NoSuchBucket";
  ErrorCodes2["NoSuchBucketPolicy"] = "NoSuchBucketPolicy";
  ErrorCodes2["NoSuchKey"] = "NoSuchKey";
  ErrorCodes2["NoSuchLifecycleConfiguration"] = "NoSuchLifecycleConfiguration";
  ErrorCodes2["NoSuchTagSet"] = "NoSuchTagSet";
  ErrorCodes2["NoSuchUpload"] = "NoSuchUpload";
  ErrorCodes2["NoSuchVersion"] = "NoSuchVersion";
  ErrorCodes2["NotImplemented"] = "NotImplemented";
  ErrorCodes2["NotSignedUp"] = "NotSignedUp";
  ErrorCodes2["OperationAborted"] = "OperationAborted";
  ErrorCodes2["PermanentRedirect"] = "PermanentRedirect";
  ErrorCodes2["PreconditionFailed"] = "PreconditionFailed";
  ErrorCodes2["Redirect"] = "Redirect";
  ErrorCodes2["RequestHeaderSectionTooLarge"] = "RequestHeaderSectionTooLarge";
  ErrorCodes2["RequestIsNotMultiPartContent"] = "RequestIsNotMultiPartContent";
  ErrorCodes2["RequestTimeout"] = "RequestTimeout";
  ErrorCodes2["RequestTimeTooSkewed"] = "RequestTimeTooSkewed";
  ErrorCodes2["RequestTorrentOfBucketError"] = "RequestTorrentOfBucketError";
  ErrorCodes2["RestoreAlreadyInProgress"] = "RestoreAlreadyInProgress";
  ErrorCodes2["ServerSideEncryptionConfigurationNotFoundError"] = "ServerSideEncryptionConfigurationNotFoundError";
  ErrorCodes2["ServiceUnavailable"] = "ServiceUnavailable";
  ErrorCodes2["SignatureDoesNotMatch"] = "SignatureDoesNotMatch";
  ErrorCodes2["SlowDown"] = "SlowDown";
  ErrorCodes2["TemporaryRedirect"] = "TemporaryRedirect";
  ErrorCodes2["TokenRefreshRequired"] = "TokenRefreshRequired";
  ErrorCodes2["TooManyAccessPoints"] = "TooManyAccessPoints";
  ErrorCodes2["TooManyBuckets"] = "TooManyBuckets";
  ErrorCodes2["UnexpectedContent"] = "UnexpectedContent";
  ErrorCodes2["UnresolvableGrantByEmailAddress"] = "UnresolvableGrantByEmailAddress";
  ErrorCodes2["UserKeyMustBeSpecified"] = "UserKeyMustBeSpecified";
  ErrorCodes2["NoSuchAccessPoint"] = "NoSuchAccessPoint";
  ErrorCodes2["InvalidTag"] = "InvalidTag";
  ErrorCodes2["MalformedPolicy"] = "MalformedPolicy";
  ErrorCodes2["BMUnknownError"] = "BMUnknownError";
  return ErrorCodes2;
})(ErrorCodes || {});
function codeToErrorMessage(code) {
  if (Object.values(ErrorCodes).includes(code)) {
    return {
      field: "file",
      message: code,
      type: UploadErrorType.BucketUpload
    };
  }
  return {
    field: "file",
    message: "BMUnknownError" /* BMUnknownError */,
    type: UploadErrorType.BucketUpload
  };
}
function categorizeAwsS3ErrorMessage(errorMessage) {
  switch (errorMessage) {
    case "EntityTooSmall" /* EntityTooSmall */:
      return BucketUploadErrorMessage.FilesizeTooSmall;
    case "EntityTooLarge" /* EntityTooLarge */:
      return BucketUploadErrorMessage.FilesizeTooLarge;
    case "UnexpectedContent" /* UnexpectedContent */:
      return BucketUploadErrorMessage.UnexpectedContent;
    case "ExpiredToken" /* ExpiredToken */:
    case "RequestTimeout" /* RequestTimeout */:
      return BucketUploadErrorMessage.Timeout;
    case "KeyTooLongError" /* KeyTooLongError */:
      return BucketUploadErrorMessage.FilepathTooLong;
    case "ServiceUnavailable" /* ServiceUnavailable */:
    case "SlowDown" /* SlowDown */:
      return BucketUploadErrorMessage.RateLimit;
    default:
      return "error";
  }
}
function wrapAwsS3ErrorMessages(errors) {
  return errors.map((error) => {
    return __spreadProps(__spreadValues({}, error), { message: categorizeAwsS3ErrorMessage(error.message) });
  });
}

class InputUploadError extends Error {
  constructor(message, errors = []) {
    super(message);
    this.errors = errors;
  }
}

var UploadStatus = /* @__PURE__ */ ((UploadStatus2) => {
  UploadStatus2["Pending"] = "pending";
  UploadStatus2["InProgress"] = "inprogress";
  UploadStatus2["Failed"] = "failed";
  UploadStatus2["Success"] = "success";
  return UploadStatus2;
})(UploadStatus || {});

var __async$1 = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
function randomFileId() {
  const chars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz".split("");
  let fileId = "";
  for (let i = 0; i < 32; i += 1) {
    fileId += chars[Math.floor(Math.random() * chars.length)];
  }
  return fileId;
}
function newUploadEntry(file) {
  return {
    errors: [],
    file,
    handle: "",
    randomFileId: `uaas_${randomFileId()}`,
    status: UploadStatus.Pending,
    uploadInfo: null
  };
}
function unwrapEtag(rawEtag) {
  if (rawEtag === null) {
    return "";
  }
  return rawEtag.replace(/^"(.+)"$/g, "$1");
}
function getAcknowledgePayload(uEntry) {
  if (uEntry.handle === "") {
    return null;
  }
  if (uEntry.uploadInfo !== null) {
    return {
      handle: uEntry.handle,
      status: "success",
      uploadInfo: uEntry.uploadInfo,
      version: "1"
    };
  }
  if (uEntry.errors.length > 0) {
    return {
      errors: uEntry.errors,
      handle: uEntry.handle,
      status: "failed",
      version: "1"
    };
  }
  return {
    handle: uEntry.handle,
    status: uEntry.status,
    version: "1"
  };
}
function uploadPreflight(baseUrl, rule, context, uEntry) {
  return __async$1(this, null, function* () {
    const preflightUrl = baseUrl;
    const rawResponse = yield window.fetch(preflightUrl, {
      body: JSON.stringify({
        upload: {
          originalFilename: uEntry.file.name,
          originalFilesize: uEntry.file.size,
          originalLastmod: uEntry.file.lastModified,
          originalMimetype: uEntry.file.type,
          ruleName: rule,
          serviceCtx: context
        }
      }),
      credentials: "include",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      method: "POST"
    });
    if (!rawResponse.ok) {
      throw new InputUploadError(
        `preflight request error: status: ${rawResponse.status} type: ${rawResponse.type}`
      );
    }
    const content = yield rawResponse.json();
    if (content.errors) {
      throw new InputUploadError(
        "There are errors in the preflight request",
        content.errors
      );
    }
    return content.data;
  });
}
function doFetchWithRetry(input, init, retries = 3) {
  return __async$1(this, null, function* () {
    let i = 0;
    while (true) {
      i += 1;
      try {
        const response = yield window.fetch(input, init);
        if (response.ok || i === retries) {
          return response;
        }
      } catch (e) {
        if (i === retries) {
          throw e;
        }
      }
    }
  });
}
function uploadFileToS3(uploadData, uEntry) {
  return __async$1(this, null, function* () {
    const formData = new FormData();
    Object.entries(uploadData.form.fields).forEach(
      ([key, val]) => formData.append(key, val)
    );
    formData.append("file", uEntry.file);
    const rawResponse = yield doFetchWithRetry(
      uploadData.form.url,
      {
        body: formData,
        method: "POST"
      },
      DEFAULT_FILE_UPLOAD_RETRIES
    );
    if (rawResponse.ok) {
      const successResult = {
        headers: {
          etag: unwrapEtag(rawResponse.headers.get("etag")),
          "x-amz-id-2": rawResponse.headers.get("x-amz-id-2"),
          "x-amz-request-id": rawResponse.headers.get("x-amz-request-id"),
          "x-amz-version-id": rawResponse.headers.get("x-amz-version-id")
        }
      };
      return successResult;
    }
    const data = yield rawResponse.text();
    const code = /<Code>([a-zA-Z]+)<\/Code>/;
    const matchedCode = data.match(code);
    if (matchedCode) {
      const errorCode = matchedCode[1];
      const errorMessage = codeToErrorMessage(errorCode);
      throw new InputUploadError("S3 upload error", [errorMessage]);
    }
    throw new InputUploadError(
      `S3 upload error: status: ${rawResponse.status} type: ${rawResponse.type}`,
      [codeToErrorMessage("BMUnknownError")]
    );
  });
}
function acknowledgeUpload(baseUrl, rule, uEntry) {
  return __async$1(this, null, function* () {
    if (getAcknowledgePayload(uEntry) === null) {
      return null;
    }
    const acknowledgeUrl = `${baseUrl}/${uEntry.handle}/ack`;
    const rawResponse = yield window.fetch(acknowledgeUrl, {
      body: JSON.stringify({
        upload: getAcknowledgePayload(uEntry)
      }),
      credentials: "include",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      method: "POST"
    });
    if (!rawResponse.ok) {
      throw new InputUploadError(
        `acknowledge request error: status: ${rawResponse.status} type: ${rawResponse.type}`
      );
    }
    const content = yield rawResponse.json();
    if (content.errors) {
      throw new InputUploadError("acknowledge request error", content.errors);
    }
    return null;
  });
}
function handleFileUpload(_0, _1, _2, _3) {
  return __async$1(this, arguments, function* (baseUrl, rule, context, upload, logger = console) {
    const start = Date.now();
    let uEntry = null;
    if (upload instanceof File) {
      uEntry = newUploadEntry(upload);
    } else {
      uEntry = upload;
    }
    if (uEntry.status !== UploadStatus.Pending) {
      return uEntry;
    }
    uEntry.status = UploadStatus.InProgress;
    logger.info("Upload preflight", {
      elapsedTime: Date.now() - start,
      step: "preflight",
      subService: "front-upload",
      timestamp: Date.now(),
      uploadEntry: uEntry
    });
    let preflightData;
    try {
      preflightData = yield uploadPreflight(baseUrl, rule, context, uEntry);
    } catch (exception) {
      if (exception instanceof InputUploadError) {
        uEntry.errors = exception.errors;
        uEntry.status = UploadStatus.Failed;
        logger.info("Upload preflight: failed (InputUploadError)", {
          elapsedTime: Date.now() - start,
          error: exception,
          step: "preflight",
          subService: "front-upload",
          timestamp: Date.now(),
          uploadEntry: uEntry
        });
        return uEntry;
      }
      const error = exception;
      logger.error("Upload preflight: failed", {
        elapsedTime: Date.now() - start,
        error,
        step: "preflight",
        subService: "front-upload",
        timestamp: Date.now(),
        uploadEntry: uEntry
      });
      throw error;
    }
    uEntry.handle = preflightData.handle;
    logger.info("Upload to S3", {
      elapsedTime: Date.now() - start,
      step: "upload-to-s3",
      subService: "front-upload",
      timestamp: Date.now(),
      uploadEntry: uEntry
    });
    let uploadInfo;
    try {
      uploadInfo = yield uploadFileToS3(preflightData, uEntry);
    } catch (exception) {
      if (exception instanceof InputUploadError) {
        uEntry.errors = exception.errors;
        uEntry.status = UploadStatus.Failed;
        logger.error("Upload to S3: failed", {
          elapsedTime: Date.now() - start,
          error: exception,
          step: "upload-to-s3",
          subService: "front-upload",
          timestamp: Date.now(),
          uploadEntry: uEntry
        });
        yield acknowledgeUpload(baseUrl, rule, uEntry);
        uEntry.errors = wrapAwsS3ErrorMessages(uEntry.errors);
        return uEntry;
      }
      const error = exception;
      logger.error("Upload to S3: failed", {
        elapsedTime: Date.now() - start,
        error,
        step: "upload-to-s3",
        subService: "front-upload",
        timestamp: Date.now(),
        uploadEntry: uEntry
      });
      throw error;
    }
    uEntry.uploadInfo = uploadInfo;
    logger.info("Upload acknowledge", {
      elapsedTime: Date.now() - start,
      step: "acknowledge",
      subService: "front-upload",
      timestamp: Date.now(),
      uploadEntry: uEntry
    });
    try {
      yield acknowledgeUpload(baseUrl, rule, uEntry);
    } catch (exception) {
      if (exception instanceof InputUploadError) {
        uEntry.errors = exception.errors;
        uEntry.status = UploadStatus.Failed;
        logger.error("Upload acknowledge: failed", {
          elapsedTime: Date.now() - start,
          error: exception,
          step: "acknowledge",
          subService: "front-upload",
          timestamp: Date.now(),
          uploadEntry: uEntry
        });
        return uEntry;
      }
      const error = exception;
      logger.error("Upload acknowledge: failed", {
        elapsedTime: Date.now() - start,
        error,
        step: "acknowledge",
        subService: "front-upload",
        timestamp: Date.now(),
        uploadEntry: uEntry
      });
      throw error;
    }
    uEntry.status = UploadStatus.Success;
    logger.info("Upload: Done", {
      elapsedTime: Date.now() - start,
      step: "upload-done",
      subService: "front-upload",
      timestamp: Date.now(),
      uploadEntry: uEntry
    });
    return uEntry;
  });
}

var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
let runningPollId = null;
function poll(_0, _1, _2) {
  return __async(this, arguments, function* (baseUrl, handle, {
    onError = () => {
    },
    onFailure,
    onPoll = () => {
    },
    onSuccess,
    onTimeout = () => {
    }
  }, {
    delay = DEFAULT_POLL_DELAY,
    maxRetries = DEFAULT_TIMEOUT / delay
  } = {}, retries = 0) {
    const statusUrl = `${baseUrl}/${handle}`;
    const rawResponse = yield window.fetch(statusUrl, {
      credentials: "include",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      method: "GET"
    });
    if (!rawResponse.ok) {
      onError(
        `Status request error: status: ${rawResponse.status} type: ${rawResponse.type}`
      );
      return () => {
      };
    }
    const content = yield rawResponse.json();
    const payload = {
      handle,
      status: content.data.status,
      statusReason: content.data.status_reason
    };
    onPoll(payload);
    switch (payload.status) {
      case UploadStatus.Success:
        onSuccess(payload);
        break;
      case UploadStatus.Failed:
        onFailure(payload);
        break;
      case UploadStatus.InProgress:
      case UploadStatus.Pending:
        if (retries >= maxRetries) {
          onTimeout();
          break;
        }
        runningPollId = setTimeout(() => {
          runningPollId = null;
          poll(
            baseUrl,
            handle,
            { onError, onFailure, onPoll, onSuccess, onTimeout },
            { delay, maxRetries },
            retries + 1
          );
        }, delay);
        break;
      default:
        onError(`Unexpected upload status "${payload.status}"!`);
        break;
    }
    return () => {
      if (runningPollId !== null) {
        clearTimeout(runningPollId);
        runningPollId = null;
      }
    };
  });
}

export { BucketUploadErrorMessage, UploadErrorType, handleFileUpload, poll };
